import {DEALS, MAX_DISCOUNT} from '../data/deals';

const TRUST_BADGES = [
  { icon: '🛍️', label: `${DEALS.length} Live Deals`  },
  { icon: '✅', label: 'Verified Links'   },
  { icon: '💸', label: `Up to ${MAX_DISCOUNT}% Off`  },
  { icon: '🔄', label: 'Updated Daily'   },
]

/**
 * Full-width hero banner with gradient background and trust signals.
 */
const HeroBanner = () => (
  <section
    aria-label="Hero banner"
    className="relative overflow-hidden bg-gradient-to-br from-brand-600 via-violet-600 to-purple-700 text-white"
  >
    {/* Decorative background blobs */}
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-16 -right-16 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-white/5 rounded-full blur-2xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-32 bg-white/5 rounded-full blur-3xl" />
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 text-center">
      {/* Eyebrow */}
      <div className="inline-flex items-center gap-2
        bg-white/15 backdrop-blur-sm border border-white/20
        rounded-full px-4 py-1.5 text-sm font-semibold mb-5">
        🎯 Verified Affiliate Deals — Updated Daily
      </div>

      {/* Headline */}
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-3 tracking-tight">
        Save Big on Every Purchase
      </h1>

      <p className="text-white/75 text-sm sm:text-base max-w-xl mx-auto mb-8 leading-relaxed">
        Curated deals from Amazon.
        All links verified. Maximum savings guaranteed.
      </p>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3">
        {TRUST_BADGES.map(({ icon, label }) => (
          <div
            key={label}
            className="flex items-center gap-1.5
              bg-white/15 backdrop-blur-sm border border-white/20
              rounded-full px-3.5 py-1.5 text-sm font-medium"
          >
            <span aria-hidden="true">{icon}</span>
            {label}
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default HeroBanner
